<template>
  <li @click="setFilter">
    <input type="checkbox" :checked="selected"/>
    <label>{{ choice.name }}({{ choice.total }})</label>
  </li>
</template>

<script setup lang="ts">
import {Category} from "../../../utils/types.ts";
import {computed, type ComputedRef} from "vue";
import {useProductStore} from "../../../store/product.ts";
import {storeToRefs} from "pinia";

const productStore = useProductStore();
const {setRequest, goToLink} = productStore;
const {prodRequest} = storeToRefs(productStore);

interface Props {
  choice: Category;
}

const props = defineProps<Props>();

const selected: ComputedRef<boolean> = computed(() => {
  if(props.choice.searchPage) {
    return !!prodRequest.value[props.choice.value]
  }else{
    return props.choice.selected === '1'
  }
});

function setFilter() {
  if(!props.choice.searchPage){
    goToLink(props.choice)
  }
  let item = prodRequest.value;
  if (selected.value) {
    delete item[props.choice.value];
  } else {
    item[props.choice.value] = true
  }
  setRequest(item);
}

</script>
